import { format } from 'date-fns';
import { PrismicBlogPageFragmentFragment } from '../../graphql-types';

export function publishDate(blogPage: PrismicBlogPageFragmentFragment) {
  const date = blogPage.data.publish_date || blogPage.first_publication_date;

  return format(new Date(date), 'MMM d, yyyy');
}
